import { WorkOrderAssignmentStatus } from "@/gql/graphql";
import { Badge } from "@/components/catalyst/badge";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "@/components/catalyst/dropdown";
import { assignmentStatusColorMap } from "@/app/ProDrivers/WorkOrders/utils/assignmentStatusColorMap";
import { useTranslations } from "use-intl";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";

const statusOrder: WorkOrderAssignmentStatus[] = [
  WorkOrderAssignmentStatus.Assigned,
  WorkOrderAssignmentStatus.OnRoad,
  WorkOrderAssignmentStatus.Delivered,
  WorkOrderAssignmentStatus.ReceiptsUploaded,
  WorkOrderAssignmentStatus.ReceiptsApproved,
  WorkOrderAssignmentStatus.Completed,
];

interface AssignmentStatusBadgeProps {
  status: WorkOrderAssignmentStatus;
  onStatusChange: (status: WorkOrderAssignmentStatus) => void;
  disabled?: boolean;
}

export function AssignmentStatusBadge({
  status,
  onStatusChange,
  disabled,
}: AssignmentStatusBadgeProps) {
  const t = useTranslations("workOrder.assignment.status");

  return (
    <Dropdown>
      <DropdownButton
        as="button"
        disabled={disabled}
        className="cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
      >
        <Badge color={assignmentStatusColorMap[status]}>
          {t(status)}
          <ChevronDownIcon className="size-4" />
        </Badge>
      </DropdownButton>
      <DropdownMenu anchor="bottom end">
        {statusOrder.map((s) => (
          <DropdownItem
            key={s}
            onClick={() => onStatusChange(s)}
            disabled={s === status}
            className="flex items-center justify-end gap-2"
          >
            {s === status ? (
              <CheckIcon className="size-4 text-green-600" />
            ) : (
              <div className="size-4" />
            )}
            <span className="text-sm">{t(s)}</span>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
